//-================ IMPORTS FOR GENERAL COMPONENT ================-\\
import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';


//-================ IMPORTS FOR SERVICES ================-\\
import { LIBRARYCCPService } from 'src/app/Services/Libraries/General-CCP/library-ccp.service';


//-================ IMPORTS FOR DEPENDENCIES ================-\\
import moment from 'moment';
import Swal from 'sweetalert2';


//-================ IMPORTS FOR INTERFACES ================-\\
import { Filter_Check_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Filter_Check_CCP.interface';
import { Headers_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Headers-CCP.interface';
import { Data_CCP_FLOWM } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Flow_Monitoring_CCP.interface';
import { UserDataService } from 'src/app/Services/Authentication/User/user-data.service';
import { GeneralRoleCDMS, typeSystemRoleCDMS } from 'src/app/types/General/RoleCDMS.type';
import { Table } from 'primeng/table';


@Component({
    selector: 'app-flow-monitoring-ccp',
    templateUrl: './flow-monitoring-ccp.component.html',
    styleUrls: ['./flow-monitoring-ccp.component.scss', '../../../../Styles/GlobalStyles.css', '../../../../Styles/FlowMGlobal.css'],
    standalone: false
})
export class FlowMonitoringCCPComponent implements OnInit {
  //+================== VIEW CHILD ==================+\\
  @ViewChild('dtFMCCP', { static: true }) dtFMCCP!: Table

  //+================== VARIABLES CREDENTIALS ==================+\\
  private ID_User_BD: number = 0;

  //+================== VARIABLES FOR COLOR SWETALERT ==================+\\
  private ColorConfirm: string = '#20a8e1';
  private ColorsCancel: string = '#fc6161';

  //+================== SEARCH ==================+\\
  public Filter_FlowM: string = '';

  //+================== VARIABLE ROLES GENERAL ==================+\\
  public RolesGeneral: typeSystemRoleCDMS = GeneralRoleCDMS;

  //+================== VARIABLES GLOBAL FILES FLOW M CCP ==================+\\
  public ALL_FLOWM_CCP: Data_CCP_FLOWM[] = [];
  public Copy_ALL_FLOWM_CCP: Data_CCP_FLOWM[] = [];
  public SelectedALL_FLOWM_CCP: Data_CCP_FLOWM[] = [];

  public LoadPage: boolean = false;
  public IsExpired: boolean = false;

  //+================== VARIABLES FOR HEADERS FM ==================+\\
  public HeadersFM: Headers_CCP[] = [
    { ID: 1, Name: 'Ruta', Position: 1, Visible: true, Key_Header: 'ROU' },
    { ID: 1, Name: 'Nombre de CCP', Position: 1, Visible: true, Key_Header: 'NAM' },
    { ID: 1, Name: 'Revisión', Position: 1, Visible: true, Key_Header: 'NOR' },
    { ID: 1, Name: 'Año de modelo', Position: 1, Visible: true, Key_Header: 'MOY' },
    { ID: 1, Name: 'Código', Position: 1, Visible: true, Key_Header: 'COD' },
    { ID: 1, Name: 'Folio', Position: 1, Visible: true, Key_Header: 'INV' },
    { ID: 1, Name: 'Revisor', Position: 1, Visible: true, Key_Header: 'REV' },
    { ID: 1, Name: 'Aprobador', Position: 1, Visible: true, Key_Header: 'APP' },
    { ID: 1, Name: 'Fecha de carga', Position: 1, Visible: true, Key_Header: 'DAC' },
    { ID: 1, Name: 'Fecha de vencimiento', Position: 1, Visible: true, Key_Header: 'DAE' },
    { ID: 1, Name: 'Estatus ', Position: 1, Visible: true, Key_Header: 'STA' },
  ]

  //+================== FOR FILTERS ==================+\\
  public Filter_Global_Check: Filter_Check_CCP = {
    Extension: [],
    Model_Year: [],
    Status: [],
    Reviewer_Name: [],
    Approver_Name: [],
    Contributor_Name: [],
  };


  //+================== VARIABLES FOR ICONS ==================+\\
  public Icons = [
    { Icon: 'fa-user-pen', Description: 'La HOE está siendo revisada' },
    { Icon: 'fa-user-clock', Description: 'El usuario está esperando a que llegue La HOE' },
    { Icon: 'fa-user-check', Description: 'La HOE ha sido revisada y aprobada' },
    { Icon: 'fa-user-xmark', Description: 'La HOE ha sido revisada y cancelada' },
    { Icon: 'fa-user-shield', Description: 'La HOE ha sido aprobada por un administrador' },
    { Icon: 'fa-user-shield', Description: 'La HOE ha sido rechazada por un administrador' },
    { Icon: 'fa-users-slash', Description: 'No existe revisor o aprobador' },
    { Icon: 'fa-person-circle-question', Description: 'No Se tienen datos del revisor o aprobador, la HOE puede ser muy antigua' }
  ];

  public UserService = inject(UserDataService);

  constructor(private Service_CCP: LIBRARYCCPService, private router: Router) {
    this.ID_User_BD = Number(localStorage.getItem('ID_U_DB'));
  }

  ngOnInit(): void {
    this.Load_Component();
  }

  //&===================== FUNCTION FOR LOAD COMPONENT FLOW MONITORING CCP =====================&\\

  private async Load_Component(): Promise<void> {

    const Loader = document.getElementById('Loader') as HTMLDivElement;
    Loader.classList.add('active');

    try {

      const ResFlow_M_CCP: any = await firstValueFrom(this.Service_CCP.Get_CCP_Created_Rel_By_User({ ID_User: this.ID_User_BD }));

      if (ResFlow_M_CCP.success) {
        this.ALL_FLOWM_CCP = ResFlow_M_CCP.operation;
        this.Copy_ALL_FLOWM_CCP = ResFlow_M_CCP.operation;
      }

      this.LoadPage = true;
      Loader.classList.remove('active');

      this.Generate_Filters();

    } catch (e) {
      Swal.fire({
        title: 'Error',
        text: '¡Error al cargar estatus HOE, recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })

      Loader.classList.remove('active');
      this.LoadPage = true;

    }


  }
  //&===================== END FUNCTION FOR LOAD COMPONENT FLOW MONITORING CCP =====================&\\



  //&===================== FUNCTIONS FOR GENERAL FLOW MONITORING CCP =====================&\\

  //-================ FUNCTION FOR MODAL HELP ================-\\
  public ToggleModalHelp(CloseOrOpen: boolean): void {
    const ModalIconsHelp = document.getElementById('ModalIconsHelp') as HTMLDivElement;
    CloseOrOpen ? ModalIconsHelp.classList.add('active') : ModalIconsHelp.classList.remove('active');
  }

  //-================ FUNCTION FOR DATE FORMAT ================-\\
  public DateFormat(Date_Created: Date): string {
    return moment(Date_Created).utc().format('DD/MM/YYYY hh:mm:ss a')
  }

  //-================ FUNCTION FOR STATUS OF CCP ================-\\
  public Status_string(Status: number): string {
    switch (Status) {
      case 1: return 'Aprobada';
      case 2: return 'Pendiente';
      case 3: return 'Rechazada';
      case 4: return 'Eliminada';
      default: return '';
    }
  }

  //-================ FUNCTION FOR SEE CCP IN CCP LIBRARY FILE MANAGER ================-\\
  public SeeCCPLibrary(URL: string): void {

    const RouteEncode: string = encodeURIComponent(URL);

    this.router.navigate([`Dashboard/CCP/FMLibraryCCP/${RouteEncode}`]);
  }

  //-================ FUNCTION GREETING ================-\\
  public GetGreeting(): string {

    let TextGTings: string = '';

    const Date_User = new Date();
    const Hour = Date_User.getHours();

    if (Hour >= 0 && Hour <= 5) {
      TextGTings = 'Buenas noches';
    } else if (Hour >= 6 && Hour <= 11) {
      TextGTings = 'Buenos días';
    } else if (Hour >= 12 && Hour <= 17) {
      TextGTings = 'Buenas tardes';
    } else if (Hour >= 18) {
      TextGTings = 'Buenas noches';
    }

    return TextGTings;
  }

  //-================ FUNCTION FOR NAME USER ================-\\
  public NameUser(): string {
    const Name_User: string = localStorage.getItem('Name_User') || '';
    return (Name_User.split(' ', 2)).join(' ');
  }

  //-================ FUNCTION FOR ASSIGNED STATUS IN CCP OF DATE EXPIRED ================-\\
  public Expiry_Status(Date_Expiration: Date): string {

    const Current_Date = moment().utc();

    const Date_Difference = moment(Date_Expiration, 'YYYY/MM/DD').utc();

    const Diference = Date_Difference.diff(Current_Date, 'days');

    if (Diference >= 16) {
      return 'NotExpired'
    } else if (Diference >= 0 && Diference <= 15) {
      return 'NearingExpired'
    } else if (Diference < 0) {
      return 'Expired'
    } else {
      return 'NotExpired'
    }
  }

  public SeeReason_Reviewer(processData: Data_CCP_FLOWM): void {

    let Comment: string | null = null;

    if (processData.CommentTaskReviewer != null) {
      Comment = processData.CommentTaskReviewer;
    }

    if (Comment === null) {
      Comment = 'El archivo fue rechazado en el antiguo sistema o sucedió algún inconveniente y no tenemos la razón de rechazo.'
    }

    if (processData.Status === 3 && processData.StatusTaskReviewer === 4) {

      Swal.fire({
        title: 'Comentarios',
        text: `¡${Comment}!`,
        confirmButtonColor: this.ColorConfirm
      })

    } else if (processData.StatusTaskReviewer === 6) {
      Swal.fire({
        title: 'Comentarios',
        html: `¡El proceso fue rechazado por el administrador!<br><br><b>Comentario: </b>${Comment}`,
        confirmButtonColor: this.ColorConfirm
      })
    }
  }

  public SeeReason_Approver(processData: Data_CCP_FLOWM): void {

    let Comment: string | null = null;

    if (processData.CommentTaskApprover != null) {
      Comment = processData.CommentTaskApprover;
    }

    if (Comment === null) {
      Comment = 'El archivo fue rechazado en el antiguo sistema o sucedió algún inconveniente y no tenemos la razón de rechazo.'
    }

    if (processData.Status === 3 && processData.StatusTaskApprover === 4) {

      Swal.fire({
        title: 'Comentarios',
        text: `¡${Comment}!`,
        confirmButtonColor: this.ColorConfirm
      })

    } else if (processData.StatusTaskApprover === 6) {
      Swal.fire({
        title: 'Comentarios',
        html: `¡El proceso fue rechazado por el administrador!<br><br><b>Comentario: </b>${Comment}`,
        confirmButtonColor: this.ColorConfirm
      })
    }
  }

  //&===================== END FUNCTIONS FOR GENERAL FLOW MONITORING CCP =====================&\\




  //&===================== FUNCTION FOR FILTER DATE EXPIRED IN CCP =====================&\\

  public Filter_Date_Expired(): void {

    (this.IsExpired) ? (this.IsExpired = false) : (this.IsExpired = true)

    let Array_Filter: Data_CCP_FLOWM[] = [];

    for (let i = 0; i < this.ALL_FLOWM_CCP.length; i++) {

      const CCPFM = this.ALL_FLOWM_CCP[i];

      let Current_Date = moment().utc();

      let Current_Date2 = moment(CCPFM.Date_Expiration, 'YYYY/MM/DD').utc();

      let Date_Difference = moment(Current_Date2, 'YYYY/MM/DD').utc();

      let Diference = Date_Difference.diff(Current_Date, 'days');

      if (15 >= Diference) {
        Array_Filter.push(CCPFM);
      }
    }

    (!this.IsExpired) ? (this.ALL_FLOWM_CCP = this.Copy_ALL_FLOWM_CCP) : (this.ALL_FLOWM_CCP = Array_Filter)

  }

  //&===================== END FUNCTION FOR FILTER DATE EXPIRED IN CCP =====================&\\




  //&===================== FUNCTION FOR FILTERS =====================&\\

  private Generate_Filters(): void {

    this.Filter_Global_Check = {
      Extension: [],
      Model_Year: [],
      Status: [],
      Reviewer_Name: [],
      Approver_Name: [],
      Contributor_Name: [],
    };

    for (const CCP of this.ALL_FLOWM_CCP) {

      CCP.Date_Created = moment(CCP.Date_Created).utc().toDate();
      CCP.Date_Expiration = moment(CCP.Date_Expiration).utc().toDate();


      if (!this.Filter_Global_Check.Model_Year.includes(CCP.Model_Year) && CCP.Model_Year !== null) {
        this.Filter_Global_Check.Model_Year.push(CCP.Model_Year);
      }

      if (!this.Filter_Global_Check.Status.includes(CCP.Status) && CCP.Status !== null) {
        this.Filter_Global_Check.Status.push(CCP.Status);
      }

      if (!this.Filter_Global_Check.Reviewer_Name.includes(CCP.Reviewer_Name) && CCP.Reviewer_Name !== null) {
        this.Filter_Global_Check.Reviewer_Name.push(CCP.Reviewer_Name);
      }

      if (!this.Filter_Global_Check.Approver_Name.includes(CCP.Approver_Name) && CCP.Approver_Name !== null) {
        this.Filter_Global_Check.Approver_Name.push(CCP.Approver_Name);
      }

      if (!this.Filter_Global_Check.Contributor_Name.includes(CCP.Contributor_Name) && CCP.Contributor_Name !== null) {
        this.Filter_Global_Check.Contributor_Name.push(CCP.Contributor_Name);
      }

    }

    if (this.UserService.UserRoleGeneralIn([this.RolesGeneral.AdministratorCCP])) {
      this.dtFMCCP.filters['Status'] = [{ value: [2], matchMode: 'in' }]
      this.dtFMCCP._filter();
    }

  }

  //&===================== END FUNCTION FOR FILTERS =====================&\\
}
